<template>
  <PrivacyDialog>
    <pull-refresh
      v-model="isLoading"
      :head-height="getSafeAreaTop() + 50"
      @refresh="onRefresh"
    >
      <!-- 下拉提示，通过 scale 实现一个缩放效果 -->
      <template #pulling="props">
        <div :style="{ paddingTop: `${getSafeAreaTop()}px` }">下拉刷新</div>
      </template>

      <!-- 释放提示 -->
      <template #loosing>
        <div :style="{ paddingTop: `${getSafeAreaTop()}px` }">释放刷新</div>
      </template>

      <!-- 加载提示 -->
      <template #loading>
        <div :style="{ paddingTop: `${getSafeAreaTop()}px` }">加载中...</div>
      </template>
      <div class="home">
        <HomeHeader :unReadMessageNum="unReadMessageNum" />
        <div class="home-content" ref="homeWrapper">
          <div style="padding: 0 12px 12px 12px; min-height: 70vh">
            <Transition name="fade">
              <Home_Notice
                :notice="notice"
                class="notice"
                v-if="notice && notice.length && SYS_NOTICE"
              />
            </Transition>

            <!--行程3期快捷入口-->
            <div :class="{ 'quick-entry-wrapper': showQuickEntry }">
              <Plugin
                from="m/bi/subsidy/plugin"
                name="HomeQuickEntry"
                :props="{
                  show: showQuickEntry,
                  router: router_,
                }"
                :emit="{
                  onShowUpdate: updateShowQuickEntry,
                }"
              >
                <template #placeholder>
                  <div class="quick-entry-content"></div>
                </template>
              </Plugin>
            </div>
            <Transition>
              <div v-if="showBanner">
                <Swiper
                  :banner-list="bannerList"
                  :loop="loop"
                  auto
                  :showDots="showDots"
                  v-if="bannerList.length"
                  class="banner-wrapper"
                />
                <content-loader
                  v-else
                  style="margin: 16px 0 12px 0"
                  :speed="2"
                  viewBox="0 0 702 176"
                  preserve-aspect-ratio="xMidYMid meet"
                >
                  <rect
                    x="0"
                    y="0"
                    rx="20"
                    ry="20"
                    :width="702"
                    :height="176"
                  />
                </content-loader>
              </div>
            </Transition>
            <!--金刚区-->
            <template v-if="showBizNav">
              <div v-if="showBizNavNew" class="nav">
                <Plugin from="m/platform/plugin/common" name="biznav">
                  <template #placeholder>
                    <ul
                      style="
                        margin-top: 16px;
                        width: 100%;
                        animation: loading 1s ease-in-out 0s infinite;
                        display: flex;
                        justify-content: space-around;
                        align-items: center;
                        flex-shrink: 0;
                      "
                    >
                      <li
                        style="
                          display: flex;
                          align-items: center;
                          flex-flow: column;
                          flex-shrink: 0;
                        "
                      >
                        <div
                          data-v-5418ba66=""
                          style="
                            flex-shrink: 0;
                            background: #f5f5f5;
                            height: 48px;
                            width: 48px;
                            border-radius: 50%;
                          "
                        ></div>
                        <span
                          style="
                            background: #f5f5f5;
                            display: block;
                            width: 40px;
                            height: 15px;
                            margin: 5px auto;
                          "
                        ></span>
                      </li>
                      <li
                        style="
                          display: flex;
                          align-items: center;
                          flex-flow: column;
                          flex-shrink: 0;
                        "
                      >
                        <div
                          data-v-5418ba66=""
                          style="
                            flex-shrink: 0;
                            background: #f5f5f5;
                            height: 48px;
                            width: 48px;
                            border-radius: 50%;
                          "
                        ></div>
                        <span
                          style="
                            background: #f5f5f5;
                            display: block;
                            width: 40px;
                            height: 15px;
                            margin: 5px auto;
                          "
                        ></span>
                      </li>
                      <li
                        style="
                          display: flex;
                          align-items: center;
                          flex-flow: column;
                          flex-shrink: 0;
                        "
                      >
                        <div
                          data-v-5418ba66=""
                          style="
                            flex-shrink: 0;
                            background: #f5f5f5;
                            height: 48px;
                            width: 48px;
                            border-radius: 50%;
                          "
                        ></div>
                        <span
                          style="
                            background: #f5f5f5;
                            display: block;
                            width: 40px;
                            height: 15px;
                            margin: 5px auto;
                          "
                        ></span>
                      </li>
                      <li
                        style="
                          display: flex;
                          align-items: center;
                          flex-flow: column;
                          flex-shrink: 0;
                        "
                      >
                        <div
                          data-v-5418ba66=""
                          style="
                            flex-shrink: 0;
                            background: #f5f5f5;
                            height: 48px;
                            width: 48px;
                            border-radius: 50%;
                          "
                        ></div>
                        <span
                          style="
                            background: #f5f5f5;
                            display: block;
                            width: 40px;
                            height: 15px;
                            margin: 5px auto;
                          "
                        ></span>
                      </li>
                    </ul>
                  </template>
                </Plugin>
              </div>
              <BizNav
                v-else
                style="margin-top: 16px"
                @rendered="updateRender('biz_nav')"
              />
            </template>
            <!--公告区-->

            <Transition name="fade">
              <Home_Card
                v-if="!isLoading"
                @hasChangeTask="hasChangeTask"
                @rendered="updateRender('home_card')"
              />
            </Transition>

            <!--近期行程区-->
            <div id="recentListWrapper">
              <div :style="{ marginBottom: guessYouWantVisible ? '12px' : 0 }">
                <Plugin
                  v-if="!isLoading && journeyReady"
                  from="m/bi/subsidy/plugin"
                  name="GuessYouWant"
                  :props="{
                    context: this,
                    enabled:
                      journeySwitchConfig?.smartJourneyEventSwitch === true,
                  }"
                  :emit="{ onStateChange: onGuessYouWantState }"
                />
              </div>
              <Transition name="fade">
                <Plugin
                  v-if="!isLoading && journeyReady"
                  from="m/bi/subsidy/plugin"
                  name="RecentItinerary"
                  :props="{
                    context: this,
                  }"
                  :emit="{
                    uploadTime: uploadflutterTime,
                  }"
                >
                </Plugin>
              </Transition>
              <div style="height: 100px"></div>
            </div>
          </div>
        </div>
      </div>
    </pull-refresh>
    <AdvertBanner />
    <AppUpdate />
    <GuidePop :show="showGuidePop" @bindBtn="bindBtn" />
  </PrivacyDialog>
</template>

<script>
import { ContentLoader } from "vue-content-loader";
import { useRouter } from "vue-router";
import $journeyPlan from "@home/data/journeyPlan";
import User from "@home/data/User";
import Common from "@home/data/common";
import proccessUrl from "../../lib/proccessUrl";
import Swiper from "./BannerSwiper";
import MobileMixins from "../../mixins/mobile";
import GuidePop from "./guidePop/index";
import memberBindApi from "../../data/memberBind";
import BizNav from "../../components/BizNav/index.vue";
import Home_Card from "./homeCard";
import Home_Notice from "./homeNotice";
import Login from "@home/data/Login2.js";
import { trace } from "app-core/lib/trace";
import PullRefresh from "vant/es/pull-refresh";
import HomeHeader from "./homeHeader";
import { getSafeAreaTop } from "@/adapter/safeArea";
import AppUpdate from "./AppUpdate.vue";
import AdvertBanner from "./AdvertBanner.vue";
import PrivacyDialog from "./PrivacyDialog.vue";
import { initXunfeiFeedbackSDK } from "./xunfeiSDK";
export default {
  components: {
    PrivacyDialog,
    AppUpdate,
    AdvertBanner,
    PullRefresh,
    HomeHeader,
    ContentLoader,
    Home_Notice,
    Home_Card,
    Swiper,
    BizNav,
    GuidePop,
  },
  mixins: [MobileMixins],
  name: "HomeTrip",
  computed: {
    showBizNav() {
      let condition = window.$ZConfig.getVal("HOME_PAGE_TOPMENU_SHOW");
      if (condition == undefined) {
        condition = true;
      }
      let r = condition;

      /** 管控临时逻辑 start
       * 如果journeySwitch的值为false且 HOME_PAGE_TOPMENU_SHOW 为 false 则展示
       */
      let journeySwitch = Boolean(this.journeySwitchConfig?.journeySwitch);
      if (!r && !journeySwitch) {
        return true;
      }
      /** 管控临时逻辑 end */
      return r;
    },
    showBizNavNew() {
      // 临时流程， 如果menuEnable为true 则显示新的金刚区， 如果为false则显示老金刚区
      return window.$ZConfig.getVal("menuEnable");
    },
  },
  data() {
    let bannerList = [];
    try {
      bannerList = JSON.parse(localStorage.getItem("SHOW_BANNER"));
    } catch (e) {
      bannerList = [];
      console.error("bannerList", e);
    }
    return {
      journeyReady: false,
      guessYouWantVisible: false,
      renderStatus: new Set(),
      headStyle: {
        height: window.$adapter.safeTopStyle(88),
        paddingTop: window.$adapter.safeTopStyle(0),
      },
      fixedRecentTop: false,
      unReadMessageNum: null,
      auto: true,
      loop: true,
      isLoading: false,
      showDots: true,
      headerTit: window.$ZConfig.getVal("NAME"),
      // 权益中心开关
      SYS_QUANYI: window.$ZConfig.getVal("SYS_QUANYI") == 1,
      notice: [], // 系统公告
      bizStopMessage: {},
      showBanner: Boolean(localStorage.getItem("SHOW_BANNER")),
      bannerList: bannerList,
      showGuidePop: false,
      SYS_NOTICE: window.$ZConfig.getVal("SYS_NOTICE") == 1,
      GRAY_HOME: window.$ZConfig.getVal("GRAY_HOME") == 1,
      journeySwitchConfig: null,
      router_: useRouter(), //传递给行程组，兼容函数式router
      showQuickEntry:
        localStorage.getItem("APP_HOME_QUICK_ENTRY_SHOW") === "true"
          ? true
          : false,
    };
  },
  created() {
    trace.tag("RENDER_HOME");
    this.getBannerList();
    this.showFederatedLoginCon();
    this.orgRangeInit();
  },
  mounted() {
    setTimeout(() => {
      window.$CS && window.$CS.show();
    }, 500);
    this.handleGetJourneySwitch();
    // 用车：高德frame在后台挂时间过久, 子应用car失活，frame会保留在屏幕上，所以要关闭该frame
    if (window.api) {
      window.api.closeFrame({ name: "carFrameApi" });
    }
    // 初始化极光推送
    window.lazyInit && window.lazyInit();
    Login.bindAppInfo();

    let url = sessionStorage.getItem("defaultUrl");
    if (url) {
      proccessUrl(url, this, {
        showLoading: true,
        autoChangeUser: true,
      });
    } else {
      this.init();
    }
    initXunfeiFeedbackSDK();
  },
  methods: {
    getSafeAreaTop,
    onGuessYouWantState({ phase }) {
      this.guessYouWantVisible = phase !== "hidden";
    },
    async orgRangeInit() {
      const res = await Common.orgRangeInit();
      const {
        data: { code },
      } = res;
      if (code != 0) {
        console.warn("orgRangeInit error");
      }
    },
    updateShowQuickEntry(e) {
      if (e === true) {
        localStorage.setItem("APP_HOME_QUICK_ENTRY_SHOW", "true");
      } else {
        localStorage.removeItem("APP_HOME_QUICK_ENTRY_SHOW");
      }
      this.showQuickEntry = e ? true : false;
    },
    async onRefresh() {
      await this.init();
      this.isLoading = false;
    },
    showData: () => {},
    uploadflutterTime(w_succ = 1) {
      this.updateRender("trip_list");
      console.log("执行成功");
      if (window.flutter_inappwebview) {
        const jsonData = window.sessionStorage.getItem("WEB_SESSION_ID");
        const uastr = navigator.userAgent.toLowerCase();
        let isAndriod = uastr.indexOf("android") !== -1;
        try {
          if (
            localStorage.getItem("flutter_home_isoperatelogin") === "false" &&
            localStorage.getItem("flutter_home_createwebviewtime") &&
            localStorage.getItem("flutter_home_startapptime")
          ) {
            const flutter_home_apptime =
              Number(localStorage.getItem("flutter_home_createwebviewtime")) -
              Number(localStorage.getItem("flutter_home_startapptime"));
            console.log("flutter_home_apptime", flutter_home_apptime);
            if (flutter_home_apptime && flutter_home_apptime < 10000) {
              window.mconsole &&
                window.mconsole.upYueYingAvg(
                  "flutter_app_native耗时_" + (isAndriod ? "android" : "ios"),
                  flutter_home_apptime,
                  217,
                );
            }
          }
        } catch (e) {
          console.log("flutter_home_apptime", "error", e);
        }

        window.mconsole &&
          window.mconsole.endUploadByPage(
            "flutter_home_start",
            {
              w_succ: w_succ,
              category: 168,
              msg: "flutter首页渲染耗时版本_" + (isAndriod ? "android" : "ios"),
              bl1: jsonData,
            },
            "/home",
            10000,
            ["pp"],
          );
        window.mconsole &&
          window.mconsole.endUploadByPage(
            "flutter_home_createwebviewtime",
            {
              w_succ: w_succ,
              category: 215,
              msg:
                "flutter-webview热启动耗时_" + (isAndriod ? "android" : "ios"),
              bl1: jsonData,
            },
            "/home",
            10000,
            ["pp"],
          );
        // if (localStorage.getItem('flutter_home_isoperatelogin') === 'false') {
        console.log(
          "冷启动时间",
          localStorage.getItem("flutter_home_startapptime"),
          new Date(Number(localStorage.getItem("flutter_home_startapptime"))),
        );
        window.mconsole &&
          window.mconsole.endUploadByPage(
            "flutter_home_startapptime",
            {
              w_succ: w_succ,
              category: 216,
              msg: "flutter从应用冷启动耗时_" + (isAndriod ? "android" : "ios"),
              bl1: "",
            },
            "/home",
            10000,
            ["pp"],
          );
        // }

        window.mconsole &&
          window.mconsole.endUploadByPage(
            "flutter_recent-trip",
            {
              w_succ: w_succ,
              category: 181,
              msg: "flutter近期行程渲染耗时",
              bl1: jsonData,
            },
            "/home",
            10000,
            ["pp"],
          );
      }
      this.uploadOtherTime();
    },
    uploadOtherTime() {
      // 首页渲染耗时
      window.mconsole &&
        window.mconsole.endUploadByPage(
          "page_time_homeindex",
          {
            w_succ: 1,
            category: 106,
            msg: "首页渲染耗时",
          },
          "/home",
          10000,
          ["pp"],
        );
      let id = 0;
      const _env = () => {
        const ua = window.navigator.userAgent.toLowerCase();
        return {
          dd: ua.indexOf("dingtalk") !== -1,
          weixin:
            ua.match(/MicroMessenger/i) == "micromessenger" &&
            ua.indexOf("wxwork/") === -1 &&
            ua.indexOf("miniprogram") === -1,
          miniprogram: ua.indexOf("miniprogram") !== -1,
          feishu: ua.indexOf("lark/") !== -1, //飞书
          wxwork: ua.indexOf("wxwork/") !== -1,
        };
      };
      const env = _env();
      if (env.dd) {
        id = 230;
      }
      if (env.feishu) {
        id = 229;
      }
      if (env.wxwork) {
        id = 228;
      }
      if (env.weixin) {
        id = 231;
      }
      if (id > 0) {
        window.mconsole &&
          window.mconsole.endUploadByPage(
            "page_time_homeindex_env",
            {
              w_succ: 1,
              category: id,
              msg: "渠道首页渲染耗时",
            },
            "/home",
            10000,
            ["pp"],
          );
      }

      // flutter sso 渲染耗时
      let isAndriod =
        navigator.userAgent.toLowerCase().indexOf("android") !== -1;
      window.mconsole &&
        window.mconsole.endUploadByPage(
          "qywx_sso_start",
          {
            w_succ: 1,
            category: 224,
            msg:
              "企业微信SSO-首页渲染耗时版本_" + (isAndriod ? "android" : "ios"),
            // bl1: jsonData
          },
          "/home",
          10000,
          ["pp"],
        );

      window.mconsole &&
        window.mconsole.endUploadByPage(
          "fs_sso_start",
          {
            w_succ: 1,
            category: 225,
            msg: "飞书SSO-首页渲染耗时版本_" + (isAndriod ? "android" : "ios"),
            // bl1: jsonData
          },
          "/home",
          10000,
          ["pp"],
        );

      window.mconsole &&
        window.mconsole.endUploadByPage(
          "dd_sso_start",
          {
            w_succ: 1,
            category: 226,
            msg: "钉钉SSO-首页渲染耗时版本_" + (isAndriod ? "android" : "ios"),
            // bl1: jsonData
          },
          "/home",
          10000,
          ["pp"],
        );

      window.mconsole &&
        window.mconsole.endUploadByPage(
          "wx_sso_start",
          {
            w_succ: 1,
            category: 227,
            msg: "微信SSO-渲染耗时版本_" + (isAndriod ? "android" : "ios"),
            // bl1: jsonData
          },
          "/home",
          10000,
          ["pp"],
        );
    },
    handleGetJourneySwitch() {
      $journeyPlan
        .journeySwitch()
        .then((res) => {
          console.log("home journeySwitchConfig", res);
          if (res.data) {
            this.journeySwitchConfig = res.data.data;
          }
        })
        .finally(() => {
          this.journeyReady = true;
        });
    },
    updateRender(e) {
      if (this.renderStatus.size <= 2) {
        this.renderStatus.add(e);
        if (this.renderStatus.size == 3) {
          trace.tag("RENDER_HOME_SUCCESS");
        }
      }
    },
    async init() {
      const arr = [this.getNotice()];
      if (window.api) {
        arr.push(this.getTask());
      }
      await Promise.all(arr);
    },
    uploadTime() {
      let fTime1 = localStorage.getItem("firstAppTime1");
      // if( fTime1 && ( window.api || window.flutter_inappwebview ) ){
      if (fTime1) {
        let endTime = new Date().getTime();
        localStorage.removeItem("isFirstLoad");
        localStorage.removeItem("firstAppTime1");
        let totalLast = endTime - fTime1;
        document.cookie =
          "applogintime=0;Path=/;Domain=.z-trip.cn;expires=" +
          new Date(0).toUTCString(); //清除当前域名下的，例如 .m.kevis.com
        // console.error('totalLast', fTime1, endTime, totalLast)
        let config = { w_succ: 1, category: 159, msg: "app进入首页耗时" };
        console.log("app进入首页耗时", totalLast);
        // 大于100秒抛弃;
        if (totalLast > 1000 * 60) {
          console.error("app进入首页耗时大于60s,丢弃数据埋点");
          return;
        }
        const reportConfig = {
          category: config.category,
          msg: config.msg,
          w_succ: typeof config.w_succ !== undefined ? config.w_succ : 1, // 命中1,未命中0
          wl_avgv1: totalLast,
        };
        console.log("app进入首页耗时", reportConfig);
        window.__wpk && window.__wpk.report(reportConfig);
      }
    },
    handleScroll(e) {
      const scrollTop = e.target.scrollTop;
      const offsetTop = document.getElementById("recentListWrapper").offsetTop;
      this.fixedRecentTop = scrollTop + 10 > offsetTop;
    },

    /**
     * 获取待办数据
     */
    async getTask() {
      try {
        const res = await User.getTasks();
        if (res.code !== "0") {
          this.$w.toast.text(
            res.msg || this.$t("APP_HOME.NYT_Z_RW_XW9RVU_AWQ_HH_DT_WC"),
          );
          return;
        }
        if (window.api) {
          window.api.setAppIconBadge({
            badge: parseInt(res.data.waitMyAuthCount),
          });
        }
      } catch (e) {
        console.log(e);
      }
    },

    /**
     * 获取banner数据
     * @param position
     */
    getBannerList(position = "home_center") {
      if (!position) return;
      User.getBannerList(position)
        .then((res) => {
          if (res.code === "0" && res.data.length > 0) {
            this.bannerList = res.data;
            localStorage.setItem(
              "SHOW_BANNER",
              JSON.stringify(this.bannerList),
            );
            this.showBanner = true;
            if (this.bannerList.length > 1) {
              this.auto = this.loop = this.showDots = true;
            } else {
              this.auto = this.loop = this.showDots = false;
            }
          } else {
            this.showBanner = false;
            localStorage.removeItem("SHOW_BANNER");
          }
        })
        .catch((err) => {
          this.showBanner = false;
          localStorage.removeItem("SHOW_BANNER");
          console.error(err);
        });
    },

    // 获取公告和各业务线停用
    async getNotice() {
      try {
        const res = await User.getNoticeAll();
        if (res.code !== "0") {
          return;
        }
        let nowTime = window.moment().valueOf();
        if (res.data && res.data.notices.length > 0) {
          res.data.notices = res.data.notices.filter((item) => {
            if (item.takeDate) {
              let takeTime = window.moment(item.takeDate).valueOf();
              if (nowTime < takeTime) return false; // 删除还未到有效期开始时间的公告
            }
            if (item.duedate) {
              let dueTime = window.moment(item.duedate).valueOf();
              if (nowTime > dueTime) return false; // 删除过了有效期的公告
            }
            return true;
          });
          this.notice = res.data.notices.filter((item) => item.title) || [];
        }

        this.bizStopMessage = res.data && res.data.stopMessage;
      } catch (e) {
        console.log(e);
      }
    },
    bindBtn(type) {
      if (type === "bind") {
        sessionStorage.setItem("showGuide", true);
        this.isShowGuide = true;
        this.$router.push({
          path: "/mg/otapub/memberBind",
        });
      } else {
        sessionStorage.setItem("showGuide", false);
        this.isShowGuide = false;
      }

      this.showGuidePop = false;
    },
    // 是否展示联合登录
    async showFederatedLoginCon() {
      const res = await memberBindApi.getStyleControl();
      if (res.code === "0") {
        sessionStorage.setItem("showAdvPop", res.data.popupWindow);
        sessionStorage.setItem("showMyPageItem", res.data.priceComparison);
        this.showGuidePop = res.data.popupWindow;
        // this.showGuidePop = true
      }
    },

    hasChangeTask(val) {
      this.unReadMessageNum = val;
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  width: 100%;
  overflow-y: scroll;
  height: 100%;
  background: #f5f6f9;
  -webkit-overflow-scrolling: touch;
  .home-content {
    position: relative;
    margin-top: -12px;
    box-sizing: border-box;
    flex: 1;
    flex-shrink: 0;
    overflow-y: scroll;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    box-sizing: border-box;
    // background-color: #fff;
  }
  .quick-entry-wrapper /deep/ .entry {
    margin-top: 0;
  }
  .quick-entry-wrapper {
    height: 64px;
    margin-top: 12px;
    overflow: hidden;
    .quick-entry-content {
      height: 64px;
      border-radius: 16px;
      overflow: hidden;
      background-color: #f2f2f2;
      position: relative;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(
          90deg,
          transparent 0%,
          rgba(255, 255, 255, 0.4) 50%,
          transparent 100%
        );
        animation: shimmer 1s infinite;
      }
    }
  }
}
.banner-wrapper {
  margin: 16px 0 0px 0;
  border-radius: 8px;
  box-shadow: 0px 2px 20px rgba(120, 154, 187, 0.2);
}
.travel-log-entry {
  padding: 0 12px;
  margin-top: -24px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.box {
  padding: 0.6rem;
  width: 100%;
  height: 10rem;
  border-radius: 0.4rem;
  background: #fff;
  box-shadow: 0 0.1rem 1rem rgba(120, 154, 187, 0.2);
}
@keyframes shimmer {
  100% {
    left: 100%;
  }
}
.nav {
  min-height: 108px;
  padding: 4px 4px 16px 4px;
  background: #fff;
  margin-top: 16px;
  box-shadow: 0 2px 20px rgba(120, 154, 187, 0.2);
  border-radius: 12px;
  transition: all 0.3s;
}
</style>
<style lang="less">
//科大讯飞样式修改
div.feedback-box {
  bottom: 300px;
  .upload-file img {
    width: 16px;
    height: auto;
    display: inline;
  }
  .feedback__dialog {
    zoom: 0.85;
  }
}
</style>
